import React from 'react';
import {Button, Dropdown, Icon, Menu, Modal, Tooltip} from 'antd';
import type {CargoDeletionTarget} from './use-delete-cargo';

interface CargoActionsProps {
    cargo: CargoDeletionTarget;
    deleteDisabled: boolean;
    deleteDisabledReason?: string;
    deleting: boolean;
    onDelete: (cargo: CargoDeletionTarget) => Promise<void>;
}

const CargoActions: React.FC<CargoActionsProps> = ({
    cargo,
    deleteDisabled,
    deleteDisabledReason,
    deleting,
    onDelete
}) => {
    const deletionUnavailable = deleteDisabled || Boolean(deleteDisabledReason);

    const actionsMenu = (
        <Menu
            selectable={false}
            onClick={({key, domEvent}) => {
                domEvent.stopPropagation();
                if (key !== 'delete' || deletionUnavailable) {
                    return;
                }

                Modal.confirm({
                    title: `Delete ${cargo.name || 'cargo'}?`,
                    content: 'This action cannot be undone.',
                    okText: 'Delete',
                    okType: 'danger',
                    onOk: () => onDelete(cargo)
                });
            }}
        >
            <Menu.Item key="delete" disabled={deletionUnavailable}>
                <Tooltip title={deleteDisabledReason} placement="left">
                    <span style={{display: 'block'}}>
                        <Icon type="delete" style={{marginRight: 8}} />
                        Delete
                    </span>
                </Tooltip>
            </Menu.Item>
        </Menu>
    );

    return (
        <span onClick={(event) => event.stopPropagation()}>
            <Dropdown overlay={actionsMenu} trigger={['hover']} placement="bottomRight">
                <Button
                    aria-label="Cargo actions"
                    title="Actions"
                    icon="more"
                    size="small"
                    loading={deleting}
                />
            </Dropdown>
        </span>
    );
};

export default CargoActions;
